import type { FC } from 'react';
import { useState } from 'react';
import { Tabs, TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import ChatPage from '../features/chat';
import Documents from '../features/documents';
import Categories from '../features/categories';
import AuthButton from '../components/Header/AuthButton';
import LanguageSwitcher from '../components/Header/LanguageSwitcher';

moment.tz.setDefault('Asia/Tokyo');

const HomePage: FC = () => {
  const { t } = useTranslation();
  const [reloadData, setReloadData] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>('1');

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <div>{t('home.chat.title')}</div>,
      children: <ChatPage reloadData={reloadData} />,
    },
    {
      key: '2',
      label: t('home.documents.title'),
      children: (
        <Documents setReloadData={setReloadData} isActive={activeTab === '2'} />
      ),
    },
    {
      key: '3',
      label: t('home.categories.title'),
      children: <Categories setReloadData={setReloadData} />,
    },
  ];

  return (
    <div style={{ height: '100vh', position: 'relative' }}>
      {/* Botões absolutamente posicionados — não competem pelo espaço do tab bar */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          display: 'flex',
          alignItems: 'center',
          height: '46px',
          zIndex: 10,
        }}
      >
        <LanguageSwitcher />
        <AuthButton />
      </div>
      <Tabs
        defaultActiveKey="1"
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        tabBarStyle={{ paddingRight: '160px' }}
        style={{ height: '100%', overflow: 'hidden' }}
      />
    </div>
  );
};

export default HomePage;
